var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('warning'),_c('roles-table'),_c('add-button')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }